import React, { useEffect, useState } from 'react';

const THERAPIES = [
  // Breast Cancer
  { id: 1, label: 'Paclitaxel + Trastuzumab', cancer: 'Breast Cancer', stage: 'Stage II' },
  { id: 2, label: 'Tamoxifen', cancer: 'Breast Cancer', stage: 'Stage I-II' },
  { id: 3, label: 'Anastrozole', cancer: 'Breast Cancer', stage: 'Stage I-III' },
  { id: 4, label: 'Letrozole', cancer: 'Breast Cancer', stage: 'Stage I-III' },
  { id: 5, label: 'Fulvestrant', cancer: 'Breast Cancer', stage: 'Stage IV' },
  { id: 6, label: 'Palbociclib', cancer: 'Breast Cancer', stage: 'Stage IV' },

  // Colorectal Cancer
  { id: 7, label: 'FOLFOX', cancer: 'Colorectal Cancer', stage: 'Stage III' },
  { id: 8, label: 'Capecitabine', cancer: 'Colorectal Cancer', stage: 'Stage II-III' },
  { id: 9, label: 'Cetuximab', cancer: 'Colorectal Cancer', stage: 'Stage IV' },
  { id: 10, label: 'Bevacizumab', cancer: 'Colorectal Cancer', stage: 'Stage IV' },
  { id: 11, label: 'Regorafenib', cancer: 'Colorectal Cancer', stage: 'Stage IV' },

  // Lung Cancer
  { id: 12, label: 'Pembrolizumab', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 13, label: 'Osimertinib', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 14, label: 'Atezolizumab', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 15, label: 'Crizotinib', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 16, label: 'Docetaxel', cancer: 'Lung Cancer', stage: 'Stage III-IV' },

  // Prostate Cancer
  { id: 17, label: 'Docetaxel', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 18, label: 'Abiraterone', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 19, label: 'Enzalutamide', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 20, label: 'Leuprolide', cancer: 'Prostate Cancer', stage: 'Stage II-IV' },

  // Pancreatic Cancer
  { id: 21, label: 'Gemcitabine', cancer: 'Pancreatic Cancer', stage: 'Stage II-IV' },
  { id: 22, label: 'FOLFIRINOX', cancer: 'Pancreatic Cancer', stage: 'Stage II-III' },
  { id: 23, label: 'Nab-paclitaxel', cancer: 'Pancreatic Cancer', stage: 'Stage IV' },

  // Ovarian Cancer
  { id: 24, label: 'Carboplatin + Paclitaxel', cancer: 'Ovarian Cancer', stage: 'Stage III-IV' },
  { id: 25, label: 'Bevacizumab', cancer: 'Ovarian Cancer', stage: 'Stage III-IV' },
  { id: 26, label: 'Olaparib', cancer: 'Ovarian Cancer', stage: 'Stage IV' },

  // Bladder Cancer
  { id: 27, label: 'Cisplatin + Gemcitabine', cancer: 'Bladder Cancer', stage: 'Stage IV' },
  { id: 28, label: 'Atezolizumab', cancer: 'Bladder Cancer', stage: 'Stage IV' },
  { id: 29, label: 'Pembrolizumab', cancer: 'Bladder Cancer', stage: 'Stage IV' },

  // Kidney Cancer
  { id: 30, label: 'Sunitinib', cancer: 'Kidney Cancer', stage: 'Stage IV' },
  { id: 31, label: 'Pazopanib', cancer: 'Kidney Cancer', stage: 'Stage IV' },
  { id: 32, label: 'Nivolumab', cancer: 'Kidney Cancer', stage: 'Stage IV' },

  // Liver Cancer
  { id: 33, label: 'Sorafenib', cancer: 'Liver Cancer', stage: 'Stage IV' },
  { id: 34, label: 'Lenvatinib', cancer: 'Liver Cancer', stage: 'Stage IV' },
  { id: 35, label: 'Atezolizumab + Bevacizumab', cancer: 'Liver Cancer', stage: 'Stage IV' },

  // Stomach Cancer
  { id: 36, label: 'Trastuzumab', cancer: 'Stomach Cancer', stage: 'Stage IV' },
  { id: 37, label: 'Ramucirumab', cancer: 'Stomach Cancer', stage: 'Stage IV' },
  { id: 38, label: 'FOLFOX', cancer: 'Stomach Cancer', stage: 'Stage II-III' },

  // Esophageal Cancer
  { id: 39, label: 'Cisplatin + Fluorouracil', cancer: 'Esophageal Cancer', stage: 'Stage II-III' },
  { id: 40, label: 'Docetaxel', cancer: 'Esophageal Cancer', stage: 'Stage IV' },

  // Head and Neck Cancer
  { id: 41, label: 'Cisplatin', cancer: 'Head and Neck Cancer', stage: 'Stage III-IV' },
  { id: 42, label: 'Cetuximab', cancer: 'Head and Neck Cancer', stage: 'Stage III-IV' },
  { id: 43, label: 'Pembrolizumab', cancer: 'Head and Neck Cancer', stage: 'Stage IV' },

  // Melanoma
  { id: 44, label: 'Dabrafenib + Trametinib', cancer: 'Melanoma', stage: 'Stage IV' },
  { id: 45, label: 'Nivolumab', cancer: 'Melanoma', stage: 'Stage IV' },
  { id: 46, label: 'Ipilimumab', cancer: 'Melanoma', stage: 'Stage IV' },

  // Leukemia
  { id: 47, label: 'Imatinib', cancer: 'Chronic Myeloid Leukemia', stage: 'All Stages' },
  { id: 48, label: 'Dasatinib', cancer: 'Chronic Myeloid Leukemia', stage: 'All Stages' },
  { id: 49, label: 'Venetoclax', cancer: 'Acute Myeloid Leukemia', stage: 'All Stages' },

  // Lymphoma
  { id: 50, label: 'Rituximab + CHOP', cancer: 'Non-Hodgkin Lymphoma', stage: 'Stage III-IV' },
  { id: 51, label: 'Brentuximab', cancer: 'Hodgkin Lymphoma', stage: 'Stage III-IV' },
  { id: 52, label: 'Ibrutinib', cancer: 'Non-Hodgkin Lymphoma', stage: 'Stage IV' },

  // Multiple Myeloma
  { id: 53, label: 'Bortezomib', cancer: 'Multiple Myeloma', stage: 'All Stages' },
  { id: 54, label: 'Lenalidomide', cancer: 'Multiple Myeloma', stage: 'All Stages' },
  { id: 55, label: 'Daratumumab', cancer: 'Multiple Myeloma', stage: 'All Stages' },

  // Thyroid Cancer
  { id: 56, label: 'Sorafenib', cancer: 'Thyroid Cancer', stage: 'Stage IV' },
  { id: 57, label: 'Lenvatinib', cancer: 'Thyroid Cancer', stage: 'Stage IV' },

  // Brain Cancer
  { id: 58, label: 'Temozolomide', cancer: 'Glioblastoma', stage: 'Stage IV' },
  { id: 59, label: 'Bevacizumab', cancer: 'Glioblastoma', stage: 'Stage IV' },

  // Cervical Cancer
  { id: 60, label: 'Cisplatin', cancer: 'Cervical Cancer', stage: 'Stage II-IV' },
  { id: 61, label: 'Bevacizumab', cancer: 'Cervical Cancer', stage: 'Stage IV' },

  // Endometrial Cancer
  { id: 62, label: 'Carboplatin + Paclitaxel', cancer: 'Endometrial Cancer', stage: 'Stage III-IV' },
  { id: 63, label: 'Pembrolizumab', cancer: 'Endometrial Cancer', stage: 'Stage IV' },
];

const CANCER_TYPES = [
  'Acute Myeloid Leukemia',
  'Bladder Cancer',
  'Brain Cancer',
  'Breast Cancer',
  'Cervical Cancer',
  'Chronic Myeloid Leukemia',
  'Colorectal Cancer',
  'Endometrial Cancer',
  'Esophageal Cancer',
  'Glioblastoma',
  'Head and Neck Cancer',
  'Hodgkin Lymphoma',
  'Kidney Cancer',
  'Liver Cancer',
  'Lung Cancer',
  'Melanoma',
  'Multiple Myeloma',
  'Non-Hodgkin Lymphoma',
  'Ovarian Cancer',
  'Pancreatic Cancer',
  'Prostate Cancer',
  'Stomach Cancer',
  'Thyroid Cancer',
];

const DISEASE_STAGES = ['Stage I', 'Stage I-II', 'Stage II', 'Stage II-III', 'Stage III', 'Stage IV', 'All Stages'];

const ONTARIO_CANCER_CENTERS = [
  'Windsor Regional Cancer Centre',
  'Verspeeten Family Cancer Centre',
  'Waterloo Regional Health Network Cancer Centre',
  'Juravinski Cancer Centre',
  'Carlo Fidani Regional Cancer Centre',
  'Odette Cancer Centre',
  'Princess Margaret Cancer Centre',
  'Stronach Regional Cancer Centre at Southlake',
  'R.S. McLaughlin Durham Regional Cancer Centre',
  'Cancer Centre of Southeastern Ontario',
  'The Ottawa Hospital Cancer Centre',
  'Simcoe Muskoka Regional Cancer Centre',
  'Northeast Cancer Centre',
  'Regional Cancer Care Northwest',
];

export default function Onboarding({ user, onComplete, initialProfile = null }) {
  const isEditMode = Boolean(initialProfile);
  const isMedicalProfessional = initialProfile?.role === 'medical_professional';
  const isGoogleAuthUser = user?.authProvider === 'google';
  const [step, setStep] = useState(isEditMode ? 'account' : (isMedicalProfessional ? 'center' : 'cancer'));
  const [accountForm, setAccountForm] = useState({
    username: user?.username || '',
    name: user?.name || '',
    email: user?.email || '',
    dateOfBirth: user?.dateOfBirth ? String(user.dateOfBirth).slice(0, 10) : '',
    password: '',
    confirmPassword: '',
  });
  const [selectedCancer, setSelectedCancer] = useState(initialProfile?.cancerType || '');
  const [selectedStage, setSelectedStage] = useState(initialProfile?.diseaseStage || '');
  const [selectedCancerCenter, setSelectedCancerCenter] = useState(initialProfile?.cancerCenter || '');
  const [selectedClinician, setSelectedClinician] = useState(initialProfile?.assignedClinician || '');
  const [selectedTherapies, setSelectedTherapies] = useState(
    initialProfile?.therapies ? initialProfile.therapies.map(t => t.id) : []
  );
  const [clinicians, setClinicians] = useState([]);
  const [cancerSearch, setCancerSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const canSelectClinician = initialProfile?.role !== 'medical_professional';

  useEffect(() => {
    const loadClinicians = async () => {
      try {
        const query = selectedCancerCenter
          ? `?cancerCenter=${encodeURIComponent(selectedCancerCenter)}`
          : '';
        const res = await fetch(`https://toxsee.onrender.com/api/clinicians${query}`);
        if (!res.ok) return;
        const data = await res.json();
        setClinicians(Array.isArray(data.clinicians) ? data.clinicians : []);
      } catch {
        // Optional enhancement; fail silently.
      }
    };

    if (canSelectClinician) {
      loadClinicians();
    }
  }, [canSelectClinician, selectedCancerCenter]);

  useEffect(() => {
    if (!selectedCancerCenter) {
      setSelectedClinician('');
      return;
    }

    if (selectedClinician && !clinicians.some(c => c.username === selectedClinician)) {
      setSelectedClinician('');
    }
  }, [selectedCancerCenter, selectedClinician, clinicians]);

  const filteredTherapies = THERAPIES.filter((t) => t.cancer === selectedCancer);

  const handleAccountChange = (event) => {
    const { name, value } = event.target;
    setAccountForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTherapyToggle = (therapyId) => {
    setSelectedTherapies((prev) =>
      prev.includes(therapyId)
        ? prev.filter((id) => id !== therapyId)
        : [...prev, therapyId]
    );
  };

  const handleNext = () => {
    if (step === 'account') {
      if (!accountForm.username || !accountForm.name || !accountForm.email || !accountForm.dateOfBirth) {
        setError('Username, name, email, and date of birth are required');
        return;
      }
      if (accountForm.username.trim().length < 3) {
        setError('Username must be at least 3 characters');
        return;
      }
      if (!isGoogleAuthUser && accountForm.password && accountForm.password.trim().length < 6) {
        setError('New password must be at least 6 characters');
        return;
      }
      if (!isGoogleAuthUser && accountForm.password && !accountForm.confirmPassword) {
        setError('Please confirm your new password');
        return;
      }
      if (!isGoogleAuthUser && accountForm.password && accountForm.password !== accountForm.confirmPassword) {
        setError('New password and confirmation do not match');
        return;
      }
      setError('');
      setStep(isMedicalProfessional ? 'center' : 'cancer');
      return;
    }
    if (step === 'center' && !selectedCancerCenter) {
      setError('Please select a cancer center');
      return;
    }
    if (step === 'cancer' && !selectedCancer) {
      setError('Please select a cancer type');
      return;
    }
    if (step === 'stage' && !selectedStage) {
      setError('Please select a disease stage');
      return;
    }
    if (step === 'therapies' && selectedTherapies.length === 0) {
      setError('Please select at least one therapy');
      return;
    }

    setError('');

    if (step === 'cancer') {
      setStep('stage');
    } else if (step === 'stage') {
      setStep('therapies');
    } else if (step === 'center') {
      handleComplete();
    } else if (step === 'therapies') {
      handleComplete();
    }
  };

  const handleComplete = async () => {
    setLoading(true);
    try {
      const accountRes = await fetch('https://toxsee.onrender.com/api/account-details', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify({
          currentUsername: user.username,
          username: accountForm.username,
          name: accountForm.name,
          email: accountForm.email,
          dateOfBirth: accountForm.dateOfBirth,
          password: isGoogleAuthUser ? '' : (accountForm.password || ''),
        }),
      });

      const accountData = await accountRes.json();
      if (!accountRes.ok) {
        throw new Error(accountData.error || 'Failed to update account details');
      }

      const therapyDetails = isMedicalProfessional
        ? []
        : selectedTherapies.map((id) => THERAPIES.find((t) => t.id === id));

      const profileData = isMedicalProfessional
        ? {
            role: initialProfile?.role || '',
            currentSituation: 'not_applicable',
            cancerType: 'not_applicable',
            diseaseStage: 'not_applicable',
            cancerCenter: selectedCancerCenter || null,
            assignedClinician: null,
            therapies: [],
          }
        : {
            role: initialProfile?.role || '',
            currentSituation: initialProfile?.currentSituation || '',
            cancerType: selectedCancer,
            diseaseStage: selectedStage,
            cancerCenter: selectedCancerCenter || null,
            assignedClinician: selectedClinician || null,
            therapies: therapyDetails,
          };

      console.log('Saving profile:', {
        username: accountData.user.username,
        cancerType: profileData.cancerType,
        diseaseStage: profileData.diseaseStage,
        cancerCenter: profileData.cancerCenter,
        therapies: profileData.therapies,
      });

      // Store locally first (this is the backup)
      localStorage.setItem('user', JSON.stringify(accountData.user));
      localStorage.setItem('userProfile', JSON.stringify(profileData));

      // Try to save to backend (optional - doesn't fail the flow if it fails)
      try {
        const res = await fetch('https://toxsee.onrender.com/api/user-profile', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          },
          body: JSON.stringify({
            username: accountData.user.username,
            cancerType: profileData.cancerType,
            diseaseStage: profileData.diseaseStage,
            cancerCenter: profileData.cancerCenter,
            assignedClinician: profileData.assignedClinician,
            therapies: profileData.therapies,
          }),
        });

        const responseData = await res.json();
        console.log('Profile save response:', responseData);

        if (!res.ok) {
          console.warn('Backend profile save failed:', responseData.error);
        }
      } catch (backendErr) {
        console.warn('Backend profile save error (continuing anyway):', backendErr);
      }

      // Complete onboarding regardless of backend status
      onComplete({
        ...profileData,
        account: accountData.user,
      });
    } catch (err) {
      console.error('Profile save error:', err);
      setError(err.message || 'Failed to save profile. Please try again.');
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (step === 'center' && isEditMode) setStep('account');
    if (step === 'cancer' && isEditMode) setStep('account');
    if (step === 'stage') setStep('cancer');
    if (step === 'therapies') setStep('stage');
    setError('');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--page-bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        padding: '40px',
        maxWidth: '500px',
        width: '100%',
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          marginBottom: '32px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: 'var(--brand-primary-light)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
          }}>
            <img src="/logo192.png" alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '4px' }} />
          </div>
          <span style={{
            fontWeight: '700',
            fontSize: '24px',
            color: 'var(--teal)',
          }}>
            Reaxano
          </span>
        </div>

        {/* Progress */}
        <div style={{
          display: 'flex',
          gap: '8px',
          marginBottom: '32px',
          justifyContent: 'center',
        }}>
          {((isEditMode ? ['account'] : []).concat(isMedicalProfessional ? ['center'] : ['cancer', 'stage', 'therapies'])).map((s) => (
            <div
              key={s}
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                background: step === s ? 'var(--teal)' : '#ddd',
              }}
            />
          ))}
        </div>

        {step === 'account' && (
          <>
            <h2 style={{
              marginBottom: '8px',
              fontSize: '22px',
              fontWeight: '600',
              color: '#1a1a1a',
            }}>
              Update Account Details
            </h2>
            <p style={{
              marginBottom: '24px',
              fontSize: '14px',
              color: '#666',
            }}>
              {isGoogleAuthUser
                ? 'Change your username, name, email, and date of birth. Google manages your sign-in.'
                : 'Change your username, name, email, date of birth, and password. New passwords must be entered twice.'}
            </p>

            {error && (
              <div style={{
                marginBottom: '16px',
                padding: '12px',
                background: '#FEE',
                border: '1px solid #FCC',
                borderRadius: '8px',
                color: '#C33',
                fontSize: '14px',
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '24px' }}>
              <input
                type="text"
                name="username"
                value={accountForm.username}
                onChange={handleAccountChange}
                placeholder="Username"
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }}
              />
              <input
                type="text"
                name="name"
                value={accountForm.name}
                onChange={handleAccountChange}
                placeholder="Full Name"
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }}
              />
              <input
                type="email"
                name="email"
                value={accountForm.email}
                onChange={handleAccountChange}
                placeholder="Email"
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }}
              />
              <input
                type="date"
                name="dateOfBirth"
                value={accountForm.dateOfBirth}
                onChange={handleAccountChange}
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }}
              />
              {!isGoogleAuthUser && (
                <>
                  <input
                    type="password"
                    name="password"
                    value={accountForm.password}
                    onChange={handleAccountChange}
                    placeholder="New Password (optional)"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                  <input
                    type="password"
                    name="confirmPassword"
                    value={accountForm.confirmPassword}
                    onChange={handleAccountChange}
                    placeholder="Confirm New Password"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                </>
              )}
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              {isEditMode && (
                <button
                  onClick={handleBack}
                  style={{
                    flex: 1,
                    padding: '12px',
                    background: 'white',
                    color: 'var(--teal)',
                    border: '1px solid var(--teal)',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                >
                  Back
                </button>
              )}
              <button
                onClick={handleNext}
                  style={{
                    flex: 1,
                    padding: '12px',
                    background: 'var(--teal)',
                    color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Next
              </button>
            </div>
          </>
        )}

        {step === 'center' && (
          <>
            <h2 style={{
              marginBottom: '8px',
              fontSize: '22px',
              fontWeight: '600',
              color: '#1a1a1a',
            }}>
              {initialProfile ? 'Update Your Cancer Center' : 'Select Your Cancer Center'}
            </h2>
            <p style={{
              marginBottom: '24px',
              fontSize: '14px',
              color: '#666',
            }}>
              {isMedicalProfessional
                ? 'Choose the Ontario cancer center where you practice.'
                : 'Choose the Ontario cancer center where you receive care.'}
            </p>

            {error && (
              <div style={{
                marginBottom: '16px',
                padding: '12px',
                background: '#FEE',
                border: '1px solid #FCC',
                borderRadius: '8px',
                color: '#C33',
                fontSize: '14px',
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px', maxHeight: '320px', overflowY: 'auto' }}>
              {ONTARIO_CANCER_CENTERS.map((center) => (
                <button
                  key={center}
                  onClick={() => setSelectedCancerCenter(center)}
                  style={{
                    padding: '14px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedCancerCenter === center ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedCancerCenter === center ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                >
                  {center}
                </button>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              {isEditMode && (
                <button
                  onClick={handleBack}
                  style={{
                    flex: 1,
                    padding: '12px',
                    background: 'white',
                    color: 'var(--teal)',
                    border: '1px solid var(--teal)',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                >
                  Back
                </button>
              )}
              <button
                onClick={handleNext}
                disabled={loading}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: 'var(--teal)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1,
                }}
              >
                {loading ? 'Saving...' : isMedicalProfessional ? 'Update Profile' : 'Next'}
              </button>
            </div>
          </>
        )}

        {/* Step 1: Cancer Type */}
        {!isMedicalProfessional && step === 'cancer' && (
          <>
            <h2 style={{
              marginBottom: '8px',
              fontSize: '22px',
              fontWeight: '600',
              color: '#1a1a1a',
            }}>
              {initialProfile ? 'Update Your Cancer Type' : 'Select Your Cancer Type'}
            </h2>
            <p style={{
              marginBottom: '24px',
              fontSize: '14px',
              color: '#666',
            }}>
              {initialProfile ? 'Update your cancer type for personalized guidance' : 'This helps us provide personalized guidance'}
            </p>

            {error && (
              <div style={{
                marginBottom: '16px',
                padding: '12px',
                background: '#FEE',
                border: '1px solid #FCC',
                borderRadius: '8px',
                color: '#C33',
                fontSize: '14px',
              }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom: '16px' }}>
              <input
                type="text"
                value={cancerSearch}
                onChange={(e) => setCancerSearch(e.target.value)}
                placeholder="Search cancer types..."
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  marginBottom: '12px',
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px', maxHeight: '300px', overflowY: 'auto' }}>
              {CANCER_TYPES.filter(cancer => 
                cancer.toLowerCase().includes(cancerSearch.toLowerCase())
              ).map((cancer) => (
                <button
                  key={cancer}
                  onClick={() => setSelectedCancer(cancer)}
                  style={{
                    padding: '12px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedCancer === cancer ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedCancer === cancer ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                >
                  {cancer}
                </button>
              ))}
            </div>

            <button
              onClick={handleNext}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'var(--teal)',
                  color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              Next
            </button>
          </>
        )}

        {/* Step 2: Disease Stage */}
        {!isMedicalProfessional && step === 'stage' && (
          <>
            <h2 style={{
              marginBottom: '8px',
              fontSize: '22px',
              fontWeight: '600',
              color: '#1a1a1a',
            }}>
              {initialProfile ? 'Update Disease Stage' : 'Select Disease Stage'}
            </h2>
            <p style={{
              marginBottom: '24px',
              fontSize: '14px',
              color: '#666',
            }}>
              For <strong>{selectedCancer}</strong>
            </p>

            {error && (
              <div style={{
                marginBottom: '16px',
                padding: '12px',
                background: '#FEE',
                border: '1px solid #FCC',
                borderRadius: '8px',
                color: '#C33',
                fontSize: '14px',
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
              {DISEASE_STAGES.map((stage) => (
                <button
                  key={stage}
                  onClick={() => setSelectedStage(stage)}
                  style={{
                    padding: '16px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedStage === stage ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedStage === stage ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '500',
                    transition: 'all 0.2s',
                  }}
                >
                  {stage}
                </button>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={handleBack}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: 'white',
                  color: 'var(--teal)',
                  border: '1px solid var(--teal)',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Back
              </button>
              <button
                onClick={handleNext}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: 'var(--teal)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Next
              </button>
            </div>
          </>
        )}

        {/* Step 3: Therapies (Multi-Select) */}
        {!isMedicalProfessional && step === 'therapies' && (
          <>
            <h2 style={{
              marginBottom: '8px',
              fontSize: '22px',
              fontWeight: '600',
              color: '#1a1a1a',
            }}>
              {initialProfile ? 'Update Your Therapies' : 'Select Your Therapies'}
            </h2>
            <p style={{
              marginBottom: '24px',
              fontSize: '14px',
              color: '#666',
            }}>
              Choose one or more therapies
            </p>

            {error && (
              <div style={{
                marginBottom: '16px',
                padding: '12px',
                background: '#FEE',
                border: '1px solid #FCC',
                borderRadius: '8px',
                color: '#C33',
                fontSize: '14px',
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
              {filteredTherapies.map((therapy) => (
                <button
                  key={therapy.id}
                  onClick={() => handleTherapyToggle(therapy.id)}
                  style={{
                    padding: '16px',
                    textAlign: 'left',
                    borderRadius: '8px',
                    border: selectedTherapies.includes(therapy.id) ? '2px solid var(--teal)' : '1px solid #ddd',
                    background: selectedTherapies.includes(therapy.id) ? 'var(--brand-primary-light)' : 'white',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <input
                      type="checkbox"
                      checked={selectedTherapies.includes(therapy.id)}
                      onChange={() => {}}
                      style={{
                        width: '18px',
                        height: '18px',
                        cursor: 'pointer',
                      }}
                    />
                    <div>
                      <div style={{ fontWeight: '600', fontSize: '16px', color: '#1a1a1a' }}>
                        {therapy.label}
                      </div>
                      <div style={{ fontSize: '13px', color: '#666' }}>
                        {therapy.stage}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>

            {canSelectClinician && (
              <div style={{ marginBottom: '24px' }}>
                <label
                  htmlFor="patient-cancer-center"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#1a1a1a',
                  }}
                >
                  Select Your Cancer Center
                </label>
                <select
                  id="patient-cancer-center"
                  value={selectedCancerCenter}
                  onChange={(e) => setSelectedCancerCenter(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    background: 'white',
                    marginBottom: '14px',
                  }}
                >
                  <option value="">Choose a cancer center</option>
                  {ONTARIO_CANCER_CENTERS.map((center) => (
                    <option key={center} value={center}>
                      {center}
                    </option>
                  ))}
                </select>

                <label
                  htmlFor="assigned-clinician"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#1a1a1a',
                  }}
                >
                  Select Your Clinician (optional)
                </label>
                <select
                  id="assigned-clinician"
                  value={selectedClinician}
                  onChange={(e) => setSelectedClinician(e.target.value)}
                  disabled={!selectedCancerCenter}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    background: 'white',
                    opacity: selectedCancerCenter ? 1 : 0.6,
                  }}
                >
                  <option value="">
                    {selectedCancerCenter ? 'No clinician selected' : 'Select a cancer center first'}
                  </option>
                  {clinicians.map((clinician) => (
                    <option key={clinician.username} value={clinician.username}>
                      {clinician.name} ({clinician.username})
                    </option>
                  ))}
                </select>
                <p style={{ marginTop: '6px', fontSize: '12px', color: '#666' }}>
                  Only clinicians from the selected cancer center are shown. You can update this later from profile editing.
                </p>
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={handleBack}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: 'white',
                  color: 'var(--teal)',
                  border: '1px solid var(--teal)',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Back
              </button>
              <button
                onClick={handleNext}
                disabled={loading}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: 'var(--teal)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1,
                }}
              >
                {loading ? 'Saving...' : initialProfile ? 'Update Profile' : 'Complete Setup'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
